<template>
  <div id="app">
    <Index></Index>
  </div>
</template>

<script>
  import Index from "./views/Index.vue"

  export default {
    name: "app",
    components: {
      Index
    },

  };
</script>

<style lang="less">
  @import url("//at.alicdn.com/t/font_2809900_q3ksfccp1jl.css");
  // @import "./assets/css/reset.css";
</style>